import {connect} from 'react-redux'
import withRouter from "../../../../components/RouterComponentWrapper";
import PublicTournamentAnsicht from "../../../../components/views/public/tournamentneu/PublicTournamentAnsicht";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";

const mapStateToProps = function (state, ownProps) {
    let tournamentId = ownProps.router.location.pathname.substring(NAVIGATION_ITEM.PUBLIC_TOURNAMENT.route.length + 1);
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    let isApp = urlParams.get('app');
    isApp = isApp !== null && isApp !== undefined && isApp.toUpperCase() === "TRUE";
    return {userId: state.user.id, isLoggedIn: state.user.isLoggedIn, tournamentId: tournamentId, appCall: isApp};
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PublicTournamentAnsicht))
